import React from "react";
import "./Dfy.styles.css";
import { BiSupport } from "react-icons/bi";

const Dfy = () => {
	return (
		<>
			<div className="right-container">
				<div className="content">
					<div className="container-fluid">
						{/* start page title  */}
						<div className="row mb-2">
							<div className="col-12 ">
								<div className="page-title-box w-100">
									<h4 className="page-title">DFY</h4>
								</div>
							</div>
						</div>
						{/* end page title  */}
						{/* Card  */}
						<div className="row">
							<div className="col-md-12">
								<div className="card w-100">
									<div className="head-part mb-0">
										<h6 className="profile-heading">Done for you</h6>
									</div>
									<div className="card-body">
										<h6 className="description-text">To Activate BookFlow AI DFY Edition, Please Contact Our Support Desk With Code <span className='fw-bold'>"31ACTIVEDFYBOOKFLOW25"</span> With Your BookFlow AI Account Details,They will set up your account - </h6>
										<div className=" mt-4 mb-3 ">
											<a className="btn btn-primary " href="https://helpsoftdealslab.tawk.help/" target="_blank"><BiSupport   fontWeight={600} color="white" style={{marginRight:"5px", marginTop:"-3px"}}/>Support Desk</a>
										</div>

									</div>
								</div>
							</div>
						</div>
						{/* End Card */}
					</div>
				</div>
			</div>
		</>
	);
};

export default Dfy;
